<template>
<el-radio-group v-model="dtheme.navbarColor" @change="change">
  <el-radio  class="primary" label="primary">
    <el-tag color="#1890ff">默认</el-tag>
  </el-radio>
  <el-radio  class="light" label="light">
    <el-tag color="#07c2fe">浅蓝</el-tag>
  </el-radio>
  <el-radio  class="deepblue" label="deepblue">
    <el-tag color="#0c65b4">深蓝</el-tag>
  </el-radio>
  <el-radio  class="info" label="info">
    <el-tag color="#ED6E4D">橙红</el-tag>
  </el-radio>
  <el-radio  class="warning" label="warning">
    <el-tag color="#FABB3D">阳光</el-tag>
  </el-radio>
  <el-radio  class="system" label="system">
    <el-tag color="#007f60">专业</el-tag>
  </el-radio>
  <el-radio  class="success" label="success">
    <el-tag color="#01bc78">生命</el-tag>
  </el-radio>
  <el-radio  class="dark" label="dark">
    <el-tag color="#464C5BE5">商务</el-tag>
  </el-radio>
</el-radio-group>
</template>
<script>
export default {
  name: 'NavBarBox',
  props: {
    theme: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dtheme: this.theme
    }
  },
  methods: {
    change() {
      // header和侧边栏同色
      this.dtheme.sidebarColor = this.dtheme.navbarColor
      this.$emit('onChange', this.dtheme)
    }
  }
}
</script> 


// WEBPACK FOOTER //
// src/views/layout/components/SkinToolbox/NavBarBox.vue